import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import TrashCansForm from './TrashCansForm';

import { Spinner } from '~ui-kit';

import { fetchTransferOrganizations } from '../../services/api.helpers';
import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { getUserOrdererOrganizationId } from '~features/user/ducks';
import { isPhoneNumberValid, removeEmptyKeys } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.wasteType) {
    errors.wasteType = 'Vaadittu';
  }

  if (!values.pickupSpace) {
    errors.pickupSpace = 'Vaadittu';
  }

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  if (!values.additionalInfo) {
    errors.additionalInfo = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const getInitialValues = (orgs, userOrgId) => {
  // const userOrganization = orgs?.find(org => org.id === userOrgId);
  // const payerOrganization = userOrganization
  //   ? {
  //       value: userOrganization?.id,
  //       label: userOrganization?.name,
  //     }
  //   : null;

  const initialValues = {
    wasteType: null,
    newContainer: false,
    pickupSpace: null,
    additionalInfo: '',
    contactPhone: '',
    infectionRisk: false,
    // payerOrganization,
  };

  return initialValues;
};

const TrashCans = props => {
  const { formId, edit } = props;
  const [organizations, setOrganizations] = useState();
  const [initialValues, setInitialValues] = useState();
  const { orderId } = useParams();
  const userOrganizationId = useSelector(state =>
    getUserOrdererOrganizationId(state)
  );

  // const organizations = useSelector(state => state.reducer.organizations);

  useEffect(() => {
    const update = async () => {
      const orgs = await fetchTransferOrganizations(formId);
      setOrganizations(orgs);
      setInitialValues(getInitialValues(orgs, userOrganizationId));
    };

    if (formId) update();
  }, [formId]);

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  if (!initialValues) return <Spinner />;

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            wasteType: values.wasteType?.map(o => o.value).join(','),
            // payerOrganization: values.payerOrganization?.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          organizations={organizations}
          formik={formikProps}
          Component={TrashCansForm}
        />
      )}
    </Formik>
  );
};

export default TrashCans;
